import React from 'react';

const ImageJs = (props) => (
    <svg {...props} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <circle id="path-1" cx="28" cy="28" r="28"/>
            <polygon id="path-2" points="0.0467185917 0.00835294118 8.28123192 0.00835294118 8.28123192 15 0.0467185917 15"/>
            <polygon id="path-4" points="0.0637253469 0.0376764706 8.32783505 0.0376764706 8.32783505 14.9582992 0.0637253469 14.9582992"/>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-466 -476)">
                <g transform="translate(120 189)">
                    <g transform="translate(54 180)">
                        <g transform="translate(292 107)">
                            <use fill="#FFF" xlinkHref="#path-1"/>
                            <circle className="background-circle" stroke="#CCC" strokeLinejoin="square" fillOpacity="0"
                                fill="#000" cx="28" cy="28" r="27.5"/>
                            <g transform="translate(14 21)">
                                <g transform="translate(9.814)">
                                    <mask id="mask-3" fill="#fff">
                                        <use xlinkHref="#path-2"/>
                                    </mask>
                                    <path d="M1.04644948,14.8612941 C1.88356289,15.2436471 2.89387216,14.8024706 3.2691299,13.9492353 L8.14748041,2.42011765 C8.32067629,2.00835294 8.32067629,1.53776471 8.17634639,1.09658824 C8.00315052,0.655411765 7.68562474,0.331882353 7.28150103,0.155411765 C7.07915052,0.0671764706 6.84851134,0.00835294118 6.61758351,0.00835294118 C5.95366598,0.00835294118 5.34719175,0.419823529 5.05853196,1.03776471 L0.180470103,12.5965882 C0.0072742268,13.0080588 0.0072742268,13.4789412 0.151604124,13.9201176 C0.3248,14.3315882 0.642325773,14.6554118 1.04644948,14.8612941"
                                        id="Fill-1" fill="#999" mask="url(#mask-3)"/>
                                </g>
                                <g transform="translate(19.629)">
                                    <mask id="mask-5" fill="#fff">
                                        <use xlinkHref="#path-4"/>
                                    </mask>
                                    <path d="M3.03802887,0.625911765 C2.72050309,0.243558824 2.25893608,0.0376764706 1.76821443,0.0376764706 C1.36380206,0.0376764706 0.95996701,0.184735294 0.671307216,0.449441176 C0.324915464,0.743558824 0.122564948,1.15532353 0.0939876289,1.62591176 C0.0648329897,2.0965 0.209162887,2.53767647 0.49782268,2.86120588 L4.3947299,7.50826471 L0.469245361,12.1553235 C-0.137228866,12.8612059 -0.050342268,13.9494412 0.642152577,14.5670882 C1.33522474,15.1553235 2.4318433,15.0670882 3.00916289,14.3906176 L7.91637938,8.62591176 C8.46512165,7.97885294 8.46512165,7.03767647 7.91637938,6.39061765 L3.03802887,0.625911765 Z"
                                        fill="#999" mask="url(#mask-5)"/>
                                </g>
                                <path d="M7.68556701,14.5294118 C8.37835052,13.9114706 8.46494845,12.8232353 7.85876289,12.1176471 L3.93298969,7.47058824 L7.85876289,2.82352941 C8.14742268,2.47058824 8.29175258,2.02941176 8.2628866,1.58823529 C8.23402062,1.11735294 8.03195876,0.705882353 7.68556701,0.411764706 C7.36804124,0.147058824 6.99278351,0 6.58865979,0 C6.09793814,0 5.63608247,0.205882353 5.3185567,0.588235294 L0.411340206,6.35294118 C-0.137113402,6.99970588 -0.137113402,7.94117647 0.411340206,8.58823529 L5.28969072,14.3526471 C5.86701031,15.0291176 6.99278351,15.1176471 7.68556701,14.5294118"
                                    fill="#999"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ImageJs;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/assets/Embed.js